"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoSize = exports.getPlayerSize = void 0;
function getPlayerSize(kalturaPlayer) {
    return kalturaPlayer ? kalturaPlayer.dimensions : { width: 0, height: 0 };
}
exports.getPlayerSize = getPlayerSize;
function getVideoSize(kalturaPlayer) {
    if (!kalturaPlayer) {
        return { width: 0, height: 0 };
    }
    var videoTrack = kalturaPlayer.getActiveTracks().video;
    if (!videoTrack ||
        videoTrack.width === undefined ||
        videoTrack.height === undefined) {
        // fallback - mainly for Safari
        if (kalturaPlayer.getVideoElement()) {
            return {
                width: kalturaPlayer.getVideoElement().videoWidth,
                height: kalturaPlayer.getVideoElement().videoHeight,
            };
        }
        return { width: 0, height: 0 };
    }
    return {
        width: videoTrack.width,
        height: videoTrack.height,
    };
}
exports.getVideoSize = getVideoSize;
//# sourceMappingURL=player-utils.js.map